export default __webpack_public_path__ + "static/media/tabel.fe359eed.png";